import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  HttpResponse,
  SadieSimulatorTurn,
  SadieSimulatorTurnRequest,
} from "@/types";

export function useSimulateSadieTurn() {
  return useMutation({
    mutationFn: async (request: SadieSimulatorTurnRequest) => {
      const res = await guacHttpClient.post<
        SadieSimulatorTurn,
        HttpResponse<SadieSimulatorTurn>
      >("relationships/simulate", request);
      return res.data;
    },
  });
}
